







































// Importing components
import LayoutApp from '@/layputs/LayoutApp.vue';
import BaseLoadingAnimation from '@/ui/BaseLoadingAnimation.vue';
import TheFormRestaurants2 from '@/components/restaurants/TheFormRestaurants2.vue';
import BaseCard from '@/ui/BaseCard.vue';
import BaseAlertList from '@/ui/BaseAlertList.vue';
import TheFormRestaurants1 from '@/components/restaurants/TheFormRestaurants1.vue';
// Importing functions
import {correctDataUpdate, updateRestaurant} from '@/ts/restaurants/update-restaurant';
import {validateRestaurant} from '@/ts/restaurants/validate-restaurant';
import {getFormData} from '@/ts/helpers';
import {getRestaurant} from '@/ts/restaurants/get-restaurant';

export default {
    name: 'PageUsersUpdate',
    components: {
        LayoutApp,
        BaseCard,
        BaseAlertList,
        TheFormRestaurants1,
        TheFormRestaurants2,
        BaseLoadingAnimation,
    },
    props: {},
    data() {
        return {
            data: Object(),
            items: Array(),
            errors: Array(),
            first_page: Boolean(true),
        };
    },
    methods: {
        next() {
            this.first_page = false;
        },
        back() {
            this.first_page = true;
        },
        onSubmit() {
            this.errors = [];

            validateRestaurant(this.errors, this.data);

            if (this.errors.length === 0) {
                this.$store.dispatch('setLoadingOn');

                correctDataUpdate(this.data);

                this.data.working_hours = JSON.stringify(this.data.working_hours);
                this.data.tags = JSON.stringify(this.data.tags);
                this.data.delivery_prices = JSON.stringify(this.data.delivery_prices);

                const formData = getFormData(this.data);
                formData.append('_method', 'PUT');

                updateRestaurant((formData as any), this.data.slug).then(() => {
                    this.$router.push({ name: 'restaurants' });
                }).catch(() => {
                    this.data.image = '';
                    this.data.cover_image = '';
                });
            }
        },
    },
    created() {
        // Initializing the items object
        this.items = [{
            text: 'Панел',
            to: {path: '/dashboard'},
        }, {
            text: 'Ресторанти',
            to: {path: '/restaurants'},
        }, {
            text: 'Редактиране',
        }];
        // Initializing the user data object
        this.data = {
            name: '', email: '', description: '', town_ekatte: '',
            phone: '', address: '', notes: '', ceo: '', tags: [],
            min_order: '0', expensiveness: '1', legal_name: '',
            image: {}, cover_image: {}, selected_province: '',
            working_hours: [], delivery_prices: [], selected_municipality: '',
        };
        this.$store.dispatch('setLoadingOn');
        // Fetching data from the API
        getRestaurant(this.$route.params.id).then((response: any) => {
            this.data = { ...this.data, ...response.restaurants[0].attributes };
            this.data.image = '';
            this.data.cover_image = '';
            for (const [index, item] of Object.entries(this.data.delivery_prices)) {
                this.data.delivery_prices[index].gift = String((item as any).gift);
            }
        }).finally(() => {
            this.$store.dispatch('setLoadingOff');
        });
    },
};
